import React from 'react';
import { motion } from 'framer-motion';

const Faq = ({ faqs }) => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1 }}
      className="mt-16 bg-white rounded-xl shadow-lg p-8"
    >
      {faqs && faqs.length > 0 && (
        <>
          <h3 className="text-2xl font-bold text-center mb-8">Frequently Asked Questions</h3>
          <div className="space-y-6 max-w-3xl mx-auto">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-200 pb-4">
                <h4 className="font-semibold text-lg text-gray-800 mb-2">{faq.question}</h4>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </motion.div>
  );
};

export default Faq;